// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Tco0","right":"Footer_right__2wdeD","buttons":"Footer_buttons__OCpJX"};